import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Dissipate = ({ textData }) => {
  return (
    <div className={styles.ctn}>
      <h1
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(textData['text25']),
        }}
      ></h1>

      <div className={styles.body}>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text26']),
          }}
        ></h5>
        <h6
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text27']),
          }}
        ></h6>
      </div>

      <video
      data-fade-in-play="true"
        autoPlay
        loop
        playsInline
        muted
        preload={true}
        src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-100w-03.mp4"
        poster="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-video-100w-03-cover.jpg"
      ></video>
    </div>
  );
};

export default Dissipate;
